import { PosProvider } from './pos-provider';
import { SQC_STATUS } from '../../main/main-constant';

export class Branch {
  shopId?: number;
  merchantId?: number;
  shopName?: string;
  shopDescription?: string;
  shopPhoto?: string;
  shopCover?: string;
  shopPhoneNo?: string;
  shopLatitude?: string;
  shopLongitude?: string;
  shopLandmark?: string;
  shopCategoryId?: number;
  shopCategoryName?: string;
  branchCode?: string;
  shopStatus?: any;
  address?: any;
  openHours?: any;
  vatAddressId?: string;
  isBatchTimePeriod?: boolean;
  nextOpenDateTime?: string;
  maximumCloseDay?: number;
  scheduleType?: string;
  provider?: PosProvider | null;
  posReferenceId?: string;
  posStatus?: string;
  posStartDate?: string;
  posStep?: number;
  isActivate?: boolean;
  shopQCStatus? : SQC_STATUS;
  rejectReason? : string[];

  constructor(Obj: any = {}) {
    this.shopId = Obj.shopId;
    this.merchantId = Obj.merchantId;
    this.shopName =  Obj.shopName;
    this.shopDescription = Obj.shopDescription;
    this.shopPhoto = Obj.shopPhoto;
    this.shopCover = Obj.shopCover;
    this.shopPhoneNo = Obj.shopPhoneNo;
    this.shopLatitude = Obj.shopLatitude;
    this.shopLongitude = Obj.shopLongitude;
    this.shopLandmark = Obj.shopLandmark;
    this.shopCategoryId = Obj.shopCategoryId;
    this.shopCategoryName = Obj.shopCategoryName;
    this.branchCode =  Obj.branchCode;
    this.shopStatus = Obj.shopStatus;
    this.address = Obj.address;
    this.openHours = Obj.openHours;
    this.vatAddressId = Obj.vatAddressId;
    this.isBatchTimePeriod = Obj.isBatchTimePeriod;
    this.nextOpenDateTime = Obj.nextOpenDateTime;
    this.maximumCloseDay = Obj.maximumCloseDay;
    this.scheduleType = Obj.scheduleType;
    this.provider = Obj.provider;
    this.posReferenceId = Obj.posReferenceId;
    this.posStatus = Obj.posStatus;
    this.posStartDate = Obj.posStartDate;
    this.posStep = Obj.posStep;
    this.isActivate = Obj.isActivate;
    this.shopQCStatus = Obj.shopQCStatus;
    this.rejectReason = Obj.rejectReason;
  }
}
